exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#obituary-module[data-v-297d9042]{display:flex;flex-direction:column;height:100%;overflow:hidden}#obituary-module[data-v-297d9042] .datatable-section{display:flex;flex-direction:column;flex-grow:1;overflow:auto}#obituary-module[data-v-297d9042] .datatable-section input[type=search]{margin:0!important}", ""]);

// exports
